export default "__VITE_ASSET__DprwRd0H__"